import React from 'react';

class Footer extends React.Component{
    render(){
        return(
            <footer>
                <div className="footer-div">
                    <p>Criado por João Pedro de Sá Oliveira</p>
                </div>
            </footer>
        );
    }
}

export default Footer;